import { createFileRoute } from "@tanstack/react-router";
import { JaziaSignIn } from "@/components/signin/JaziaSignIn";

export const Route = createFileRoute("/signin")({
  component: JaziaSignIn,
});
